export class CssBreakpoints {
    private static instance: CssBreakpoints;
    private readonly tabletBreakpointPixels: number;

    public static get(): CssBreakpoints {
        if (!CssBreakpoints.instance) {
            CssBreakpoints.instance = new CssBreakpoints();
        }
        return CssBreakpoints.instance;
    }

    public isDesktop(): boolean {
        return window.innerWidth >= this.tabletBreakpointPixels;
    }

    private constructor() {
        this.tabletBreakpointPixels = this.computeTableBreakpointInPixels()
    }

    private computeTableBreakpointInPixels(): number {
        const rootStyles = getComputedStyle(document.documentElement);
        return this.cssValueToPixels(rootStyles.getPropertyValue('--wl-tablet-breakpoint').trim());
    }

    private cssValueToPixels(value: string): number {
        const temp = document.createElement('div');
        temp.style.width = value;
        document.body.appendChild(temp);
        const pixels = temp.offsetWidth;
        document.body.removeChild(temp);
        return pixels;
    }
}